import { createSelector } from '@reduxjs/toolkit';
import { OrdersState } from './types';

const selectBase = createSelector(
	(state: RootState) => state,
	(state: RootState) => state.ordersReducer,
);

export const selectResetBooking = createSelector(
	selectBase,
	(state: OrdersState) => state.reset,
);

export const selectOrders = createSelector(
	selectBase,
	(state: OrdersState) => state.orders,
);

export const selectOrdersDelayed = createSelector(
	selectBase,
	(state: OrdersState) => state.ordersDelayed,
);

export const selectOrdersByTable = createSelector(
	selectBase,
	(state: OrdersState) => state.ordersByTable,
);

export const selectLoadedTable = createSelector(
	selectBase,
	(state: OrdersState) => state.loadedTable,
);

export const selectOrdersError = createSelector(
	selectBase,
	(state: OrdersState) => state.error,
);

export const selectOrdersLoader = createSelector(
	selectBase,
	(state: OrdersState) => state.loading,
);

export const selectOrderLoader = createSelector(
	selectBase,
	(state: OrdersState) => state.loadingDetail,
);

export const selectOrderBookingData = createSelector(
	selectBase,
	(state: OrdersState) => state.orderBookingData,
);

export const selectInitialOrderBookingData = createSelector(
	selectBase,
	(state: OrdersState) => state.orderBookingDataInitial,
);

export const selectOrderDetail = createSelector(
	selectBase,
	(state: OrdersState) => state.orderDetail,
);

export const selectOrderDetailPerson = createSelector(
	selectBase,
	(state: OrdersState) => state.orderDetailPerson,
);

export const selectOrderInfoDetailPerson = createSelector(
	selectBase,
	(state: OrdersState) => state.orderInfoDetailPerson,
);

export const selectOrdersGroups = createSelector(
	selectBase,
	(state: OrdersState) => state.ordersGroups,
);

export const selectOrdersByDate = createSelector(
	selectBase,
	(state: OrdersState) => state.ordersByDate?.[0]?.orders || [],
);

export const selectOrdersGroupsLoader = createSelector(
	selectBase,
	(state: OrdersState) => state.loadingOrderGroups,
);

export const selectOrderId = createSelector(
	selectBase,
	(state: OrdersState) => state.selectedOrderId,
);

export const selectStats = createSelector(
	selectBase,
	(state: OrdersState) => state.stats,
);

export const selectWaitingOrders = createSelector(
	selectBase,
	(state: OrdersState) => state.waitingOrders,
);

export const selectLoaderWaitingOrders = createSelector(
	selectBase,
	(state: OrdersState) => state.loadingWaitingOrders,
);

export const selectOrdersByPerson = createSelector(
	selectBase,
	(state: OrdersState) => state.ordersByPerson,
);

export const selectOrdersByPersonLoader = createSelector(
	selectBase,
	(state: OrdersState) => state.loadingOrdersByPerson,
);

export const selectOrdersByPersonError = createSelector(
	selectBase,
	(state: OrdersState) => state.errorOrdersByPerson,
);

export const selectOrderForBooking = createSelector(
	selectBase,
	(state: OrdersState) => state.orderDetail,
);

export const selectOrderInfoForBooking = createSelector(
	selectBase,
	(state: OrdersState) => state.orderInfoDetail,
);

export const selectBookingThreadMod = createSelector(
	selectBase,
	(state: OrdersState) => state.bookingThreadMod,
);

export const selectBookingApplicationMod = createSelector(
	selectBase,
	(state: OrdersState) => state.bookingApplicationMod,
);

export const selectBookingIsNew = createSelector(
	selectBase,
	(state: OrdersState) => state.bookingIsNew,
);

export const selectBookingIsEdit = createSelector(
	selectBase,
	(state: OrdersState) => state.bookingIsEdit,
);

export const selectLoadingError = createSelector(
	selectBase,
	(state: OrdersState) => state.loadingError,
);

export const selectOrdersWaitingNext = createSelector(
	selectBase,
	(state: OrdersState) => state.ordersWaitingNext?.[0]?.orders || [],
);

export const selectOrdersDelayedNext = createSelector(
	selectBase,
	(state: OrdersState) => state.ordersDelayedNext,
);

export const selectLoadingNext = createSelector(
	selectBase,
	(state: OrdersState) => state.loadingNext,
);

export const selectOrdersSearchNext = createSelector(
	selectBase,
	(state: OrdersState) => state.ordersSearchNext,
);

export const selectPaymentProviders = createSelector(
	selectBase,
	(state: OrdersState) => state.paymentProviders,
);

export const selectActiveDeposite = createSelector(
	selectBase,
	(state: OrdersState) => state.orderDetail?.deposit,
);

export const selectActiveProvider = createSelector(
	selectBase,
	(state: OrdersState) => state.activeProvider,
);

export const selectAllowDepositeActions = createSelector(
	selectBase,
	(state: OrdersState) => state.allowDepositeActions,
);

export const selectPaymentProvidersMap = createSelector(
	selectBase,
	(state: OrdersState) => {
		const map = new Map();
		state.paymentProviders.forEach(paymentProvider => {
			map.set(paymentProvider.id, paymentProvider.backend.verbose_name);
		});

		return map;
  },
);

export const selectToBookingButtonDisabled = createSelector(
	selectBase,
	(state: OrdersState) => state.toBookingButtonDisabled,
);